var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('td-navbar'),_c('b-container',{attrs:{"fluid":"","id":"app"}},[_c('b-overlay',{staticStyle:{"max-height":"100vh"},attrs:{"show":_vm.isLoading,"spinner-variant":"primary"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }